class PerPage {
    constructor(container, options = {}) {
        this.container = container
        this.title = options.title || 'Показывать по'
        this.perPage = options.perPage || []
        this.onPerPageChange = options.onPerPageChange || (() => {})

        this.init()
    }

    init() {
        this.render()
        this.attachEvents()
    }

    render() {
        const perPageTitle = document.createElement('span')
        perPageTitle.classList.add('per-page__title')
        perPageTitle.textContent = this.title

        this.container.appendChild(perPageTitle)

        this.perPage.forEach((item) => {
            const perPageItem = document.createElement('span')
            perPageItem.classList.add('per-page__item')
            perPageItem.textContent = item

            const perPageItemWrapper = document.createElement('div')
            perPageItemWrapper.classList.add('per-page__item-wrapper')
            perPageItemWrapper.appendChild(perPageItem)

            this.container.appendChild(perPageItemWrapper)
        })

        const activeElement = this.container.querySelector('.per-page__item-wrapper')

        if (activeElement) {
            this.chooseOption(activeElement)

            const firstItem = activeElement.querySelector('.per-page__item')
            const firstValue = parseInt(firstItem.textContent)
            this.onPerPageChange(firstValue)
        }
    }

    chooseOption(activeElement) {
        // Ищем ВСЕ элементы внутри контейнера
        const items = this.container.querySelectorAll('.per-page__item-wrapper')
        items.forEach((item) => {
            item.classList.remove('per-page__item-wrapper--active')
        })

        if (activeElement) {
            activeElement.classList.add('per-page__item-wrapper--active')
        }
    }

    attachEvents() {
        const items = this.container.querySelectorAll('.per-page__item-wrapper')
        items.forEach((item) => {
            item.addEventListener('click', () => {
                const itemChild = item.querySelector('.per-page__item')
                const perPage = parseInt(itemChild.textContent)
                this.chooseOption(item)
                this.onPerPageChange(perPage)
            })
        })
    }
}

export default PerPage
